import DriverCell from './component';
import { withHandlers, compose } from 'recompose';
import { connect } from 'react-redux';

import { filterJobs } from 'redux/modules/jobs/effects';
import { getTotalsByDriver } from 'redux/modules/journeys/selectors';

import { getAssignedFilters } from 'redux/modules/jobs/selectors';
import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['driver', 'isFinished', 'start_time_from'];

const enhance = compose(
  withJourneyCardSelectors,
  connect(
    (state, props) => {
      const {
        driver,
        isFinished,
        start_time_from: timeFrom,
      } = props.selectors.getJourneyFields(state, props.journeyId, fields);
      const filters = getAssignedFilters(state);

      const { id: driverId, contact_name: driverName } = driver || {};

      const totalsByDriver = getTotalsByDriver(state, filters);
      const totalNumber = driver && totalsByDriver && totalsByDriver[driverId];

      return {
        driverId,
        driverName,
        filters,
        totalNumber: isFinished ? 0 : totalNumber,
        isClickable: !isFinished,
        timeFrom,
      };
    },
    { filterJobs }
  ),
  withHandlers({
    filterByDriverName:
      ({ filters, driverId, driverName, filterJobs }) =>
      (e) => {
        e.stopPropagation();

        filterJobs(
          {
            ...filters,
            driver: {
              id: driverId,
              label: driverName,
              value: driverId,
            },
          },
          { section: 'ASSIGNED' }
        );
      },
  })
);

export default enhance(DriverCell);
